import { EntityTypes } from './enums';
import { SupportStatus } from './enums/supportStatus';

export interface SupportTicket {
  ticketId: string;
  entityType: EntityTypes.supportTicket;
  userId: string;
  userName: string;
  userEmail: string;
  orgName: string;
  subject: string;
  location: string;
  description: string;
  log: string[];
  status: SupportStatus;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSupportTicketAPIProps {
  userId: string;
  subject: string;
  location: string;
  description: string;
}

export interface CreateSupportTicketProps {
  userId: string;
  userName: string;
  userEmail: string;
  orgName: string;
  subject: string;
  location: string;
  description: string;
}

export interface UpdateSupportTicketProps {
  ticketId: string;
  status: SupportStatus;
  logEntry?: string;
}

export interface SupportTicketsResponse {
  tickets: SupportTicket[];
  exclusiveStartKey?: string;
}

export interface FeedbackSubmission {
  submissionId: string;
  entityType: EntityTypes.feedbackSubmission;
  userId: string;
  userName: string;
  userEmail: string;
  orgName: string;
  entries: FeedbackEntry[];
  createdAt: number;
}

export interface FeedbackEntry {
  question: string;
  rating?: number;
  comments?: string;
}

export interface CreateFeedbackSubmissionAPIProps {
  userId: string;
  entries: FeedbackEntry[];
}

export interface CreateFeedbackSubmissionProps {
  userId: string;
  userName: string;
  userEmail: string;
  orgName: string;
  entries: FeedbackEntry[];
}

export interface SupportTicketItem extends Omit<SupportTicket, 'ticketId'> {
  PK: string;
  orgId: string;
  ticketId?: string;
}

export interface FeedbackSubmissionItem
  extends Omit<FeedbackSubmission, 'submissionId'> {
  PK: string;
  orgId: string;
  submissionId?: string;
}
